<template>
  <tbody>
  <DebugServices name="GTM"
                 :enabled="useRuntimeConfig().public.gtm.enabled">
    {{useRuntimeConfig().public.gtm.id}}
  </DebugServices>

  <DebugServices name="Builder API Key"
                 :enabled="useRuntimeConfig().public.builderApiKey ? true : false">
    {{useRuntimeConfig().public.builderApiKey}}
  </DebugServices>

  <DebugServices name="Redis"
                 :enabled="services.redis.enabled">
    {{services.redis.host}}
  </DebugServices>

  <DebugServices name="DataDog Browser Logs"
                 :enabled="services.dataDogBrowserLogs.enabled">
    {{services.dataDogBrowserLogs.clientToken}}
  </DebugServices>

  <DebugServices name="DataDog Rum"
                 :enabled="services.dataDogBrowserRum.enabled">
    {{services.dataDogBrowserRum.clientToken}}
  </DebugServices>

  <DebugServices name="Bazaar Voice">
    {{useRuntimeConfig().public.bazaarvoiceApiKey}}
  </DebugServices>

  <DebugServices name="Woosmap API Key">
    {{useRuntimeConfig().public.woosmapApiKey}}
  </DebugServices>

  <DebugServices name="Loqate Key">
    {{useRuntimeConfig().public.loqatePcaKey}}
  </DebugServices>

  <DebugServices name="Algolia API Key">
    {{useRuntimeConfig().public.algoliaApiKey}}
  </DebugServices>

  <DebugServices name="OneTrust">
    {{useRuntimeConfig().public.oneTrustDataDomainScript}}
  </DebugServices>



  </tbody>
</template>
<script setup>
import DebugServices from "~/components/debug/DebugServices.vue";

const debugStore = useDebugStore();
const services = debugStore.services;

</script>